class AdpTimelineContextualMenuController {
  constructor() {
    this.name = 'adpTimelineContextualMenu';
  }
}

export default AdpTimelineContextualMenuController;



// WEBPACK FOOTER //
// ./src/app/components/adpTimelineContextualMenu/adpTimelineContextualMenu.controller.js